export enum TimelineValue {
  TODAY = "days",
  LAST_WEEK = "weeks",
  LAST_MONTH = "months",
  LAST_YEAR = "years",
}
